import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import type { SiteSettings } from '@/types/property';

/**
 * Hook for fetching full site settings (admin only).
 * Direct table access is restricted to admins via RLS.
 * For public pages, use usePublicSiteSettings instead.
 */
export function useSiteSettings() {
  return useQuery({
    queryKey: ['site-settings'],
    queryFn: async (): Promise<SiteSettings> => {
      const { data, error } = await supabase
        .from('site_settings')
        .select('*')
        .limit(1)
        .single();

      if (error) throw error;
      return data as SiteSettings;
    },
  });
}
